import { Layout } from 'antd'
import React from 'react'

export default function Footer() {
    return <></>
    return <div>
        <Layout.Footer style={{ padding: 0 }}>
            <div style={{ textAlign: 'center', }}>
                Copyright {new Date().getFullYear()} © dientrang.love
            </div>
        </Layout.Footer>
    </div>
}
